<template>
  <div
    :class="$b()"
  >
    <BaseRow class="page-title">
      <BaseHeading
        tag="h1"
        size="h1"
      >
        Get INSPIRED by the Insta Shop.
      </BaseHeading>
    </BaseRow>

    <BaseRow>
      <InstagramGrid
        :posts="60"
        :desktop-rows="2"
      />
    </BaseRow>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'InstashopPage',

  setup() {
    const { getDescription } = useMetaHelper()

    useHead({
      meta: [
        ...getDescription('Get inspired by the SunGod Instagram shop.'),
      ]
    })
  }
})
</script>

<style lang="postcss">
.InstashopPage {
  @apply mt-[60px];

  @screen md {
    @apply mt-40;
  }

  .page-title {
    @apply global-wrapper mb-[60px];

    @screen md {
      @apply mb-20;
    }
  }

}
</style>
